export const FAILED = Symbol('FAILED');
export const LOADING = Symbol('LOADING');
export const READY = Symbol('READY');
